import {
  Box,
  Checkbox,
  Group,
  Input,
  SegmentedControl,
  Text,
} from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LAST_ORGANIC_MAX_DATE } from '../utils/constants';
import { useOrganicFieldEffects } from '../utils/use-organic-field-effects';
import { useValidationFormContext } from '../utils/validation-form';

interface ValidationFormProps {
  currentFieldIndex: number;
}

export const ValidationForm: FC<ValidationFormProps> = ({
  currentFieldIndex,
}) => {
  const { t } = useTranslation();
  const form = useValidationFormContext();
  const { paths, validateLastOrganicIfNeeded } =
    useOrganicFieldEffects(currentFieldIndex);
  const field = form.values.fields[currentFieldIndex];

  return (
    <div>
      <Text mb="sm" mt="md">
        {t('farmer-validation.form-introduction')}
      </Text>
      <Group align="flex-start" mb="md">
        <Input.Wrapper
          error={form.errors[paths.organic]}
          required
          style={{ flex: 1 }}
        >
          <SegmentedControl
            data={[
              { label: t('common.yes'), value: 'oui' },
              { label: t('common.no'), value: 'non' },
            ]}
            fullWidth
            key={form.key(paths.organic)}
            onChange={(value) =>
              form.setFieldValue(paths.organic, value as 'oui' | 'non')
            }
            value={field?.organic}
          />
        </Input.Wrapper>
        <DatePickerInput
          clearable
          disabled={field?.organic !== 'oui'}
          dropdownType="modal"
          leftSection={<IconCalendar aria-hidden size={18} stroke={1.5} />}
          leftSectionPointerEvents="none"
          maxDate={LAST_ORGANIC_MAX_DATE}
          modalProps={{ onClose: validateLastOrganicIfNeeded }}
          placeholder={t('farmer-validation.last-organic-placeholder')}
          style={{ flex: 1 }}
          valueFormat="DD/MM/YYYY"
          withAsterisk={field?.organic === 'oui'}
          {...form.getInputProps(paths.lastOrganic)}
        />
      </Group>
      {field?.organic === 'non' ? (
        <Box>
          <Text mb="sm">{t('farmer-validation.sampler-intervention')}</Text>
          <Checkbox
            key={form.key(paths.isValidated)}
            {...form.getInputProps(paths.isValidated, {
              type: 'checkbox',
            })}
            error={form.errors[paths.isValidated]}
            label={t('farmer-validation.is_validated-label')}
            size="md"
          />
        </Box>
      ) : null}
    </div>
  );
};
